<template>
  <tbody :key="`btn`">
    <th class="py-0">
      <button
        @click="btnNovoGrupo"
        ref="btnShow"
        type="button"
        class="mt-2 mb-2 btn btn-light btn-sm">
        +NOVO GRUPO
      </button>
    </th>
    <template v-for="(operadora, indexo) in cenarios[0].operadoras">
      <b-th
        class="py-0 bg-white"
        v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
        :key="`novo-grupo-0-${indexo}-${plano.id}-${indexp}`" />
    </template>
  </tbody>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters("cenario", {
      cenarios: "getCenarios"
    }),
  },
  methods: {
    ...mapActions("cenario", ["updateId", "recuperaCenario"]),
    async btnNovoGrupo() {
      await this.updateId({ id: null })
      await this.recuperaCenario({ id: null })
      this.$bvModal.show("modal-idade");
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, [])
    }
  }
}
</script>

<style>

</style>
